/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import InputWithLabel from '../../components/InputWithLabel';
import Card, { CardSection } from '../../components/card/Card';
import ContentWrapper from '../../components/ContentWrapper';

const Login = (props) => (
  <ContentWrapper>
    <Card>
      <CardSection>
        <form onSubmit={props.onSubmit}>
          <div>
            <InputWithLabel
              value={props.email}
              onChange={(e) => { props.onChangeEmail(e.target.value); }}
              type="email"
              label={<FormattedMessage id="loginEmail.email.field.label" />}
              name="email"
              isInvalid={!!props.errorMessage}
              invalidHint={props.errorMessage}
              onFocus={props.onFocus}
              isClearable
              clearValue={() => { props.onChangeEmail(''); }}
            />
          </div>
          <input type="submit" style={{ visibility: 'hidden' }} />
        </form>
      </CardSection>
    </Card>
  </ContentWrapper>
);
Login.propTypes = {
  email: PropTypes.string,
  onChangeEmail: PropTypes.func,
  onFocus: PropTypes.func,
  onSubmit: PropTypes.func,
  goToSignup: PropTypes.func,
  errorMessage: PropTypes.element,
};

export default Login;
